module.exports = __webpack_public_path__ + "assets/img/33_1566.06e85020.jpg";